export enum Modal {
  gallery = 'gallery',
  lightbox = 'lightbox',
}

export const navigatePush = (url: URL, state?: { modal: Modal }) => {
  window.history.pushState(state, '', url);
};
